// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {store} from './store'
import * as firebase from 'firebase'
import VueAnalytics from 'vue-analytics'
import 'bulma/css/bulma.css'
import 'mdi/css/materialdesignicons.min.css'

// Vue.use(Buefy)

Vue.config.productionTip = false
Vue.use(VueAnalytics, {
  id: 'UA-118020734-1',
  router,
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    firebase.initializeApp({
      apiKey: "AIzaSyDakv4sfqcG7_KObMoW1JbMmG-U9p2KzZs",
      authDomain: "atlhotwings-b7c43.firebaseapp.com",
      databaseURL: "https://atlhotwings-b7c43.firebaseio.com",
      projectId: "atlhotwings-b7c43",
      storageBucket: "atlhotwings-b7c43.appspot.com",
      messagingSenderId: "137349454948"
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignin', user)
        this.$store.dispatch('fetchUserData')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js